<template>
  <div class="grid-table-wrapper">
    <table>
      <grid-col-group v-if="columns && columns.length" :columns="columns" />
      <slot />
    </table>
  </div>
</template>
<script>
import GridColGroup from "@/components/grid/ColGroup";
import "@/components/grid/grid-sass.scss";
export default {
  name: "grid-table-wrapper",
  components: { GridColGroup },
  props: {
    columns: Array,
  },
};
</script>
<style scoped></style>
